import React from 'react';
import { AlertCircle, Send, Square } from 'lucide-react';

const InputArea = ({ 
  apiKey,
  currentConversationId,
  inputMessage,
  setInputMessage,
  isLoading,
  sendMessage,
  stopGeneration,
  openApiKeyModal 
}) => {
  return (
    <div className="input-area">
      <div className="input-container">
        {!apiKey && (
          <div className="warning-message">
            <AlertCircle className="icon-small" />
            <p>
              メッセージを送信するには
              <button onClick={openApiKeyModal} className="link">
                APIキーの設定
              </button>
              が必要です
            </p>
          </div>
        )}
        
        <div className="input-row">
          <textarea
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyDown={(e) => {
              // PCではShift+Enterで改行、Enterで送信
              // モバイルでは改行キーは改行、明示的な送信ボタンタップで送信
              if (e.key === 'Enter') {
                // モバイルデバイスかどうかを判定
                const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                
                if (!isMobile && !e.shiftKey) {
                  // PCの場合: Shift+Enterでない場合は送信
                  e.preventDefault();
                  sendMessage();
                }
                // モバイルの場合: Enterキーは常に改行（デフォルトの動作）
                // PCの場合: Shift+Enterは改行（デフォルトの動作）
              }
            }}
            placeholder={apiKey ? "メッセージを入力...\n（PCではShift+Enter、スマホでは改行キーで改行）" : "APIキーを設定してください"}
            disabled={!currentConversationId || isLoading || !apiKey}
            className="message-input"
            rows={2}
            style={{
              minHeight: '60px',
              maxHeight: '160px',
              resize: 'none',
              overflow: 'auto'
            }}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = Math.min(e.target.scrollHeight, 160) + 'px';
            }}
          />
          <button
            onClick={isLoading ? stopGeneration : sendMessage}
            disabled={!currentConversationId || (!inputMessage.trim() && !isLoading) || !apiKey}
            className={`send-btn ${isLoading ? 'stop-btn' : ''}`}
            title={isLoading ? '生成を停止' : 'メッセージを送信'}
          >
            {isLoading ? (
              <>
                <Square className="icon-small" />
                停止
              </>
            ) : (
              <>
                <Send className="icon-small" />
                送信
              </>
            )}
          </button>
        </div>
        
        <p className="disclaimer">
          ※ AIによる回答であり、内容の正確性を保証するものではありません。重要な判断は専門家にご相談ください。
        </p>
      </div>
    </div>
  );
};

export default InputArea;